import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonApiService } from 'src/app/services/common-api.service';
import { HttpHeaders } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { isThisHour } from 'date-fns';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-create-user-page',
  templateUrl: './create-user-page.component.html',
  styleUrls: ['./create-user-page.component.css'],
})
export class CreateUserPageComponent implements OnInit {
  userCreationForm!: FormGroup;
  // listForm!: FormGroup;
  passwordVisible = false;
  listArray = [];
  dbList = [];
  bpList: any = [];
  dbData: any;
  bpData: any;
  customerDetails: any;
  dbDetails: any;
  userRole = 'Customer';

  constructor(
    private fb: FormBuilder,
    private apiService: CommonApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router,
    private modal: NzModalService
  ) {}

  ngOnInit(): void {
    this.userCreationForm = this.fb.group({
      userName: [null, [Validators.required]],
      userEmail: [null, [Validators.email, Validators.required]],
      password: [null, [Validators.required]],
      userPhoneNumber: [null, [Validators.required]],
      inActive: [true],
      // type: ['Customer', [Validators.required]],
    });

    this.listArray = [];
    this.getLegalEntity();
  }

  createUser() {
    if (this.userCreationForm.valid) {
      if (this.listArray.length > 0 || this.userRole == 'Admin') {
        this.spinner.show();
        // console.log(this.userCreationForm.value);
        // API HEADER DATA STARTS
        let options = {
          headers: new HttpHeaders().set(
            'Content-Type',
            'application/x-www-form-urlencoded'
          ),
        };
        // API HEADER DATA ENDS

        // API BODY DATA STARTS
        let body = new URLSearchParams();
        body.set('username', this.userCreationForm.value.userName);
        body.set('email', this.userCreationForm.value.userEmail);
        body.set('password', this.userCreationForm.value.password);
        body.set('phone', this.userCreationForm.value.userPhoneNumber);
        body.set('role', this.userRole);
        // body.set('inActive', this.userCreationForm.value.inActive);
        body.set('sapCode', localStorage.getItem('grlksftygesap'));
        body.set('dbAccess', JSON.stringify({ requestValue: this.listArray }));
        // API BODY DATA STARTS

        // CALL API POST METHOD FROM SERVICE
        // console.log(body);
        this.apiService
          .commonPostMethod(
            body.toString(),
            environment.url + 'signup',
            options
          )
          .subscribe((response: any) => {
            // console.log(response);
            if (response.status == 'success') {
              this.toastr.success(response.message, '', { timeOut: 2500 });
              this.spinner.hide();
              this.router.navigate(['/user-management/manage-user']);
              this.userCreationForm.reset();
            } else {
              this.toastr.error(response.message, '', { timeOut: 2500 });
              this.spinner.hide();
            }
          });
      } else {
        this.selectEntityAlert('Please Add Legal Entity and Company List !');
      }
    } else {
      Object.values(this.userCreationForm.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  createList() {
    if (this.dbData && this.bpData) {
      let temp = [];
      if (this.listArray.length > 0) {
        for (let i = 0; i < this.listArray.length; i++) {
          temp.push(this.listArray[i].dbDetails.dbName);
        }
        if (temp.indexOf(this.reqValues.dbDetails.dbName) == -1) {
          this.listArray.push(this.reqValues);
        } else {
          this.entityAlert();
        }
      } else {
        this.listArray.push(this.reqValues);
      }
      this.reqValues = {};
      this.dbData = '';
      this.bpData = '';
    } else {
      // Object.values(this.listForm.controls).forEach((control) => {
      //   if (control.invalid) {
      //     control.markAsDirty();
      //     control.updateValueAndValidity({ onlySelf: true });
      //   }
      // });
      this.selectEntityAlert('Please Select Legal Entity and Company List !');
    }
  }

  getLegalEntity() {
    let options = {
      headers: new HttpHeaders().set(
        'Authorization',
        'Bearer ' + localStorage.getItem('lkjhgfdsa')
      ),
    };
    let body = new URLSearchParams();
    this.apiService
      .commonPostMethod(
        body.toString(),
        environment.newUrl + 'api/DBList',
        options
      )
      .subscribe((data: any) => {
        // console.log(data);
        this.dbList = data.responseData;
      });
  }

  getBpList() {
    // console.log(this.dbData);
    this.bpData = '';
    this.structureDBArray(this.dbData, this.dbList, 'db');
    var role;
    if (this.userRole == 'Customer') {
      role = 'CustomerList';
    } else if (this.userRole == 'Supplier') {
      role = 'SupplierList';
    }

    let options = {
      headers: new HttpHeaders()
        .set('Authorization', 'Bearer ' + localStorage.getItem('lkjhgfdsa'))
        .set('Content-Type', 'application/json'),
    };

    let body = {
      DBCode: this.dbData,
    };

    this.apiService
      .commonPostMethod(body, environment.newUrl + 'api/' + role, options)
      .subscribe((data: any) => {
        // console.log(data);
        this.bpList = data.responseData;
      });
  }

  reqValues: any = {};

  structureDBArray(data, list, code) {
    // console.log(data);
    for (let i = 0; i < list.length; i++) {
      if (code == 'bp') {
        if (list[i].bpCode == data) {
          this.customerDetails = list[i];
        }
        this.reqValues.companyDetails = this.customerDetails;
      } else if (code == 'db') {
        if (list[i].dbCode == data) {
          this.dbDetails = list[i];
          this.reqValues.dbDetails = this.dbDetails;
        }
      }
    }
  }

  roleChange() {
    // console.log(this.userRole);
    this.reqValues = {};
    this.listArray = [];
    this.bpList = [];
    this.bpData = '';
    this.dbData = '';
  }

  clearList(index) {
    this.listArray.splice(index, 1);
    // console.log(this.listArray);
  }

  entityAlert() {
    this.modal.error({
      nzTitle: 'Legal Entity already Added !',
      nzContent: 'Remove Entity or Select Another Entity',
    });
  }

  selectEntityAlert(alert) {
    this.modal.error({
      nzTitle: alert,
      // nzContent: 'Remove Entity or Select Another Entity',
    });
  }
}
